// extracted by mini-css-extract-plugin
export default {"melodyVideo":"YZ-z","isFullWidth":"ZZ-z","landingPageVideo":"_Z-z","play":"a0-z","iframeVideo":"b0-z","playHidden":"c0-z","fullwidth":"d0-z"};